import { z } from 'zod'

const isoDate = z.iso.datetime({ offset: true })

export const OperationsDependency = z
  .object({
    id: z.enum(['verifier-api', 'browser-run', 'workflow', 'd1', 'r2', 'ai-gateway']),
    label: z.string().min(1).max(100),
    status: z.enum(['healthy', 'degraded', 'disabled', 'unknown']),
    detail: z.string().min(1).max(500)
  })
  .strict()
export type OperationsDependency = z.infer<typeof OperationsDependency>

export const OperationsSnapshot = z
  .object({
    schemaVersion: z.literal(1),
    generatedAt: isoDate,
    status: z.enum(['healthy', 'degraded', 'disabled']),
    dependencies: z.array(OperationsDependency).min(1).max(20),
    activity: z
      .object({
        totalRuns: z.number().int().nonnegative(),
        runs24h: z.number().int().nonnegative(),
        activeRuns: z.number().int().nonnegative(),
        artifactBytes: z.number().int().nonnegative()
      })
      .strict(),
    limits: z
      .object({
        activeRuns: z.number().int().positive(),
        activeRunsPerRepository: z.number().int().positive(),
        activeRunsPerPullRequest: z.number().int().positive(),
        runsPerActorHour: z.number().int().positive(),
        modelRequestsPerActorHour: z.number().int().positive(),
        requestsPerActorMinute: z.number().int().positive(),
        artifactBytes: z.number().int().positive(),
        artifactBytesPerRun: z.number().int().positive()
      })
      .strict(),
    retention: z
      .object({
        passingEvidenceDays: z.number().int().positive(),
        passingReportDays: z.number().int().positive(),
        nonPassingEvidenceDays: z.number().int().positive(),
        scheduledCleanup: z.boolean()
      })
      .strict(),
    controls: z
      .object({
        acceptingRuns: z.boolean(),
        aiInferenceEnabled: z.boolean(),
        ciRepository: z.string().min(1).max(300),
        previewHostSuffixes: z.array(z.string().min(1).max(253)).min(1).max(20),
        dnsPublicAddressRequired: z.boolean(),
        originIsolationEnabled: z.boolean()
      })
      .strict()
  })
  .strict()
export type OperationsSnapshot = z.infer<typeof OperationsSnapshot>
